<template>
  <div class="coverageResult">
    <div v-if="payload.length === 0" class="coverage-intro" v-html="t('chatbot_coverage_no-coverage', { topic: t(`chatbot_topic_${localTopic}`) })"/>
    <div v-if="payload.length === 1" class="coverage-intro" v-html="t('chatbot_coverage_intro-singular', { topic: t(`chatbot_topic_${localTopic}`) })"/>
    <div v-if="payload.length > 1" class="coverage-intro" v-html="t('chatbot_coverage_intro-plural', { topic: t(`chatbot_topic_${localTopic}`) })"/>
    <ul v-for="(coverage, index) in payload" :key="index">
      <hr>
      <li v-if="coverage.productIdentifier !== 'NONE'">
        <div class="product-name" v-if="payload.length > 1">
          <span>{{ coverage.productName }}</span>
        </div>
        <div class="coverage-name" v-html="t(`chatbot_coverage_${coverage.coverageKey}`)"></div>
        <div class="coverage-name" v-if="coverage.kvgAndVvgCoverageKey" v-html="t(`chatbot_coverage_${coverage.kvgAndVvgCoverageKey}`)"></div>
      </li>
    </ul>
    <ChatBotNotSupported v-if="payload.notSupported" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import ChatBotNotSupported from './ChatBotNotSupported'
import { useI36n } from '@jota-one/i36n/src/index.vue2'

export default {
  name: 'ChatBotCoverageResult',
  components: {
    ChatBotNotSupported
  },
  props: ['coverageResult', 'topic'],

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  data () {
    return {
      payload: null,
      localTopic: null
    }
  },
  created () {
    this.payload = cloneDeep(this.coverageResult)
    this.localTopic = cloneDeep(this.topic)
    this.handleNoCoverage(this.payload)
  },
  methods: {
    handleNoCoverage (payload) {
      if (payload.length > 0 && payload.every(result => result.productIdentifier === 'NONE')) {
        Object.assign(payload, { notSupported: true })
      }
    }
  }
}
</script>

<style scoped lang="postcss">
  .coverageResult {
    padding: 10px 0;
  }

  .coverageResult li, .coverage-intro {
    list-style: none;
    padding-bottom: 12px;
    font-size: 15px;
    line-height: 20px;
    color: black;
  }

  .coverage-name {
    padding-top: 5px;
  }

  .product-name {
    font-weight: bold;
  }

  hr {
    background-color: var(--tw-c-cool-gray);
    margin-bottom: 10px;
  }
</style>
